import React from 'react';

const ComponentTitle = ({
    compTitlePart1 = '',
    compTitlePart2 = '',
    fontColor = 'text-blue-green',
    showDash = false,
    tag = 'span'
}) => {
    return React.createElement(
        tag,
        {
            className: `comp-title d-flex flex-row align-items-end maxis-extraBold fs-sm-34 fs-lg-48 fs-md-34 ls-n05 lh-lg-121 ${
                compTitlePart2 ? 'lh-090' : 'lh-171'
            } ${fontColor}`
        },
        compTitlePart1,
        compTitlePart2 && <br />,
        compTitlePart2,
        showDash && ' —'
    );
};

export default ComponentTitle;
